export const isDefaultLabRecord = (record?: { docType?: string } | null) =>
  record?.docType === "default";

export const getDefaultRecordEditTooltip = (
  record?: { docType?: string } | null
) =>
  isDefaultLabRecord(record) ? "Default records cannot be edited" : "";

export const getDefaultRecordDeleteTooltip = (
  record?: { docType?: string } | null
) =>
  isDefaultLabRecord(record) ? "Default records cannot be deleted" : "";
